import { Component, AfterViewInit, Inject, PLATFORM_ID, HostListener } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import * as AOS from 'aos';

@Component({
  selector: 'app-empower-youth',
  templateUrl: './empower-youth.component.html',
  styleUrls: ['./empower-youth.component.css']
})
export class EmpowerYouthComponent {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}
  
  isNavOpen = false;

  // navTog button click → toggle
  toggleNav(): void {
    this.isNavOpen = !this.isNavOpen;
  }

  // Link click pe close
  closeNav(): void {
    this.isNavOpen = false;
  }

  // Nav ke bahar click pe close
  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.unav')) {
      this.isNavOpen = false;
    }
  }
  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      import('aos').then(AOS => {
        AOS.default.init({
          duration: 1000,
          once: true
        });
      });
    }
  }

  activeTab: string = 'p254';

  showPanel(id: string): void {
    this.activeTab = id;
  }
}
